export const ORDER_ADV_STATUSES = {
  INPUT: 'input',
  VALIDATE: 'validate',
  PROCESSED: 'processed',
  ARCHIVED: 'archived',
  CANCELED: 'canceled',
} as const;

export type OrderAdvStatus = typeof ORDER_ADV_STATUSES[keyof typeof ORDER_ADV_STATUSES];
